import React, { forwardRef, useImperativeHandle, useState, useRef, useEffect } from 'react';

const CompanyCellEditor = forwardRef((props, ref) => {
  const companies = props.context?.companies || [];
  const [search, setSearch] = useState('');
  const [selected, setSelected] = useState(props.value || '');
  const inputRef = useRef();

  useImperativeHandle(ref, () => ({
    getValue: () => selected,
    isPopup: () => true,
    getPopupPosition: () => 'under',
  }));

  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 20);
  }, []);

  const filtered = companies
    .filter(c => {
      const q = search.toLowerCase();
      return c.name.toLowerCase().includes(q) || c.id.toLowerCase().includes(q);
    })
    .slice(0, 40);

  function pick(id) {
    setSelected(id);
    props.stopEditing(false);
  }

  return (
    <div style={{
      background: '#fff',
      border: '1px solid #ddd',
      borderRadius: 4,
      boxShadow: '0 4px 16px rgba(0,0,0,0.18)',
      width: 360,
      maxHeight: 300,
      display: 'flex',
      flexDirection: 'column',
    }}>
      <input
        ref={inputRef}
        value={search}
        onChange={e => setSearch(e.target.value)}
        placeholder="Search by name or ID..."
        style={{
          padding: '8px 12px',
          border: 'none',
          borderBottom: '1px solid #eee',
          fontSize: 13,
          outline: 'none',
        }}
        onKeyDown={e => {
          if (e.key === 'Escape') { props.stopEditing(true); }
          if (e.key === 'Enter' && filtered.length === 1) pick(filtered[0].id);
        }}
      />
      <div style={{ overflowY: 'auto', flex: 1 }}>
        {filtered.map(c => (
          <div
            key={c.id}
            onMouseDown={e => { e.preventDefault(); pick(c.id); }}
            style={{
              padding: '7px 12px',
              cursor: 'pointer',
              fontSize: 12,
              background: c.id.toLowerCase() === selected.toLowerCase() ? '#e3f2fd' : undefined,
            }}
            onMouseEnter={e => { e.currentTarget.style.background = '#f5f5f5'; }}
            onMouseLeave={e => {
              e.currentTarget.style.background =
                c.id.toLowerCase() === selected.toLowerCase() ? '#e3f2fd' : '';
            }}
          >
            {c.name}
          </div>
        ))}
        {filtered.length === 0 && (
          <div style={{ padding: '10px 12px', color: '#999', fontSize: 12 }}>No matches</div>
        )}
      </div>
    </div>
  );
});

CompanyCellEditor.displayName = 'CompanyCellEditor';
export default CompanyCellEditor;
